import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/zh-cn/services/quality-assurance/qualified-person-qp-responsible-person-rp")({
  beforeLoad: () => { throw redirect({ to: "/zh-cn/services/quality-assurance/qp-rp-prrc-services", statusCode: 301 }); },
});
